import React, { useContext, useEffect } from 'react';
import axios from 'axios';

import { LinearProgress, Button, Box } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import { DataGridPremium, GridToolbar } from '@mui/x-data-grid-premium';

import { DistributionCheckContext } from '../../../context/DistributionCheckContext.js';
import { apiRoute } from '../../../App.js';

const DistributionCheckTable = (props) => {
    const { handleOpen, setSelectedCheck, modal, setLoadingCheck } = props;

    const { rows, loading, loadData } = useContext(DistributionCheckContext);

    const getRow = (params) => setSelectedCheck(params.row);

    const handlePrint = (id, checkNum, checkDate) => {
        setLoadingCheck(true);
        axios.get(`${apiRoute}/api/PrintDisbursementChecks/Reprint?checkId=${id}&checkDate=${checkDate}&checkNum=${checkNum}`, { responseType: 'arraybuffer' })
            .then((response) => {
                const arrayBufferView = new Uint8Array(response.data);
                const blob = new Blob([arrayBufferView], { type: 'application/pdf' });
                const dataUrl = URL.createObjectURL(blob);
                window.open(dataUrl, '_blank');
            })
            .catch(error => {
                console.error('Error fetching report from front end:', error);
            })
            .finally(() => setLoadingCheck(false));
    }; 

    const columns = [
        {
            field: 'payeeName',
            headerName: 'Receiving Entities',
            flex: 2
        },
        {
            field: 'remitterAddress',
            headerName: "Receiving Entities Address",
            flex: 2
        },
        {
            id: 'checkNumber',
            field: 'checkNumber',
            headerName: 'Check #',
            headerAlign: 'center',
            align: 'center',
            flex: 1
        },
        {
            field: 'checkAmount',
            headerName: 'Check Amount',
            headerAlign: 'right',
            align: 'right',
            flex: 1,
            valueFormatter: (params) => new Intl.NumberFormat('en-us', {style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(params || 0.00),
        },
        {
            field: 'date',
            headerName: 'Print Date',
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            type: 'dateTime',
            valueGetter: (params) => new Date(params.row?.date ?? new Date()),
            renderCell: (params) => {
                const { row } = params
                const formattedDate = new Date(row.date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                });

                return <div>{formattedDate}</div>
                ;
            }
            // render cell property: pass in params and call renderDate method
        },
        {
            field: 'view',
            headerName: 'View',
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Button
                        fullWidth
                        variant="contained"
                        sx={{ backgroundColor: 'steelblue', color: 'white' }}
                        onClick={() => handlePrint(row.pkFfCheckId, row.checkNumber, row.date)}
                        disabled={modal}
                    >
                        View Check
                    </Button>
                )
            }
        },
        {
            field: 'print',
            headerName: 'Print',
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            renderCell: () => {
                return (
                    <Button fullWidth variant="contained" sx={{ backgroundColor: 'steelblue', color: 'white' }} onClick={handleOpen} disabled={modal}>
                        <PrintIcon />
                    </Button>
                )
            }
        }
    ];

    useEffect(() => {
        loadData();
    }, [])

    return (
        <Box sx={{ height: '65vh' }}>
            <DataGridPremium
                rows={[...rows].sort((a, b) => {
                    return a?.disburseId - b?.disburseId
                })}
                columns={columns}
                loading={loading}
                disableMultipleRowSelection
                onRowClick={getRow}
                initialState={{
                    sorting: { sortModel: [{ field: 'date', sort: 'desc' }] },
                    density: "standard"
                }}
                slots={{
                    toolbar: GridToolbar,
                    loadingOverlay: LinearProgress
                }}
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                        printOptions: { disableToolbarButton: true },
                    },
                }}
                localeText={{
                    noRowsLabel:
                        'No Distribution Checks Found',
                }}
                rowHeight={60}
                sx={{
                    ".MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel": {
                        marginTop: "1em",
                        marginBottom: "1em"
                    },
                    "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                        outline: "none !important",
                    }, "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus": {
                        outline: "none !important",
                    },
                    maxHeight: '65vh',
                }}
            />
        </Box>
    )
}

export default DistributionCheckTable;